import { COMPARE_MODE } from '../../components/pages/reports/consts';
import { ADWORDS_DISPLAY_NAME, FACEBOOK_DISPLAY_NAME, SOURCE_FIELD } from '../../utils/reportsConsts';

const MIN_AMOUNT_ALL_SOURCES = 5;

export default {
    reports: (dim, adminModeEnabled, reportMode) => {
        return reportMode === COMPARE_MODE ? dim.is_comparison_default : dim.is_default;
    },
    pivot: (dim, adminModeEnabled, reportMode) => {
        return dim.is_default;
    },
    creatives: (dim, adminModeEnabled, reportMode) => {
        return dim.is_default;
    },
    anonymousReport: (dim, adminModeEnabled, reportMode) => {
        return dim.is_default;
    },
    permissions: (dim, adminModeEnabled, reportMode) => {
        return dim.is_default;
    },
    fraudProtected: (dim, adminModeEnabled, reportMode) => {
        if (dim.type === 'metric' || dim.type === 'dimension') {
            return dim.fraud_protected_default;
        } else {
            return dim.is_default;
        }
    },
    fraudSuspicious: (dim, adminModeEnabled, reportMode) => {
        if (dim.type === 'metric' || dim.type === 'dimension') {
            return dim.fraud_suspicious_default;
        } else {
            return dim.is_default;
        }
    },
    fraudRejected: (dim, adminModeEnabled, reportMode) => {
        if (dim.is_cohort) {
            return false;
        }
        if (dim.type === 'metric' || dim.type === 'dimension' || dim.actual_type === 'periods') {
            return !!dim.fraud_rejected_default;
        } else {
            return dim.is_default;
        }
    },
    adMonetization: (dim, adminModeEnabled) => {
        return dim.is_admon_default;
    },
    crossDevice: (dim, adminModeEnabled, reportMode) => {
        return dim.is_default;
    },
    skan: (dim, adminModeEnabled, reportMode) => {
        return dim.is_default;
    },
    skanSummary: (dim, adminModeEnabled, reportMode) => {
        return dim.is_default;
    },
    unifiedReport: (dim, adminModeEnabled) => {
        return typeof dim.is_unified_report_default === 'boolean' ? dim.is_unified_report_default : dim.is_default;
    },
    creativeExplore: (dim, adminModeEnabled, reportMode, selectedSources) => {
        if (!selectedSources?.length) return dim.is_default;

        const {
            facebook: facebookRules = {},
            adwords: adwordsRules = {},
            other: otherRules = {},
            all_sources: allSourcesRules = {},
            any: anyRules = {},
        } = dim.source_mapping || {};

        const hasAllSourcesRule = allSourcesRules.hasOwnProperty('is_default');
        const hasFacebookRule = facebookRules.hasOwnProperty('is_default');
        const hasAdwordsRule = adwordsRules.hasOwnProperty('is_default');
        const hasOtherRule = otherRules.hasOwnProperty('is_default');
        const hasAnyRule = anyRules.hasOwnProperty('is_default');

        if (!hasAllSourcesRule && !hasFacebookRule && !hasAdwordsRule && !hasOtherRule && !hasAnyRule)
            return dim.is_default;

        const containsFacebook = selectedSources.includes(FACEBOOK_DISPLAY_NAME);
        const containsAdwords = selectedSources.includes(ADWORDS_DISPLAY_NAME);
        let isDefault = false;

        if (dim.name === SOURCE_FIELD && selectedSources.length > 1) {
            return true;
        }

        if (hasAnyRule) {
            return anyRules.is_default;
        }

        if (hasAllSourcesRule && selectedSources.length >= MIN_AMOUNT_ALL_SOURCES) {
            return allSourcesRules.is_default;
        }

        if (!containsFacebook && !containsAdwords && hasOtherRule) {
            return otherRules.is_default;
        }

        if (containsFacebook && hasFacebookRule) {
            isDefault ||= facebookRules.is_default;
        }

        if (containsAdwords && hasAdwordsRule) {
            isDefault ||= adwordsRules.is_default;
        }

        return isDefault;
    },
    force: dim => {
        return dim.force_default;
    },
};
